import { createSlice } from '@reduxjs/toolkit';
import { UserList } from '@src/api/responses/UsersResponse';

interface OTPAuth {
	value: {
		expiryTime: number;
		phoneNumber: string;
	};
}

const initialState: OTPAuth = {
	value: {
		expiryTime: new Date().getTime() * 60 * 1000,
		phoneNumber: '',
	},
};

export const otpAuthSlice = createSlice({
	name: 'otpAuth',
	initialState,
	reducers: {
		setotpAuth: (state, otpAuth) => {
			state.value = otpAuth.payload;
		},
	},
});

// Action creators are generated for each case reducer function
export const { setotpAuth } = otpAuthSlice.actions;

export default otpAuthSlice.reducer;
